<div class="value-label">
  <div class="value"
    [class.large]="type === 'currency'">{{ displayValue }}</div>
  <div class="label">{{ label }}</div>
</div>

